 
import React from 'react';

import Passed from '../passed/passed';
import Advisory from '../advisory/advisory';
import { AttributeItem } from '../../../../common/style';

interface Props {
    name: string;
    children?: JSX.Element[] | JSX.Element | string;
    passed: boolean;
}

const Attribute: React.FC<Props> = ({ name, passed, children = '' }) => (
    <AttributeItem>
        {passed ? <Passed name={name} /> : <Advisory name={name}>{children}</Advisory>}
    </AttributeItem>
);

export default Attribute;
